import { createValidator, minRange, required } from 'util/validation'

import {
  ConsultaSeguimentoAplicacaoItemModel,
  ConsultaSeguimentoAplicacaoModel,
  ConsultaSeguimentoFieldModel,
  ConsultaSeguimentoPerguntaStatusEnum,
} from './model-consultaSeguimento'
import { validatorConsultaSeguimentoPergunta01 } from './perguntas/consulta-seguimento-pergunta-01/validator-consultaSeguimentoPergunta01'
import { validatorConsultaSeguimentoPergunta02 } from './perguntas/consulta-seguimento-pergunta-02/validator-consultaSeguimentoPergunta02'
import { validatorConsultaSeguimentoPergunta03 } from './perguntas/consulta-seguimento-pergunta-03/validator-consultaSeguimentoPergunta03'
import { validatorConsultaSeguimentoPergunta04 } from './perguntas/consulta-seguimento-pergunta-04/validator-consultaSeguimentoPergunta04'
import { validatorConsultaSeguimentoPergunta06 } from './perguntas/consulta-seguimento-pergunta-06/validator-consultaSeguimentoPergunta06'
import { validatorConsultaSeguimentoPergunta07 } from './perguntas/consulta-seguimento-pergunta-07/validator-consultaSeguimentoPergunta07'
import { validatorConsultaSeguimentoPergunta08 } from './perguntas/consulta-seguimento-pergunta-08/validator-consultaSeguimentoPergunta08'
import { validatorConsultaSeguimentoPergunta13 } from './perguntas/consulta-seguimento-pergunta-13/validator-consultaSeguimentoPergunta13'
import { validatorConsultaSeguimentoPergunta15 } from './perguntas/consulta-seguimento-pergunta-15/validator-consultaSeguimentoPergunta15'
import { validatorConsultaSeguimentoPergunta17 } from './perguntas/consulta-seguimento-pergunta-17/validator-consultaSeguimentoPergunta17'
import { validatorConsultaSeguimentoPergunta19 } from './perguntas/consulta-seguimento-pergunta-19/validator-consultaSeguimentoPergunta19'

export const validatorConsultaSeguimento = createValidator<ConsultaSeguimentoFieldModel>({
  perguntasSelecionadas: (perguntasSelecionadas) => [
    required(perguntasSelecionadas),
    minRange(3)(perguntasSelecionadas.length),
  ],
  aplicacao: createValidator<ConsultaSeguimentoAplicacaoModel>({
    PERGUNTA_01: validatorConsultaSeguimentoPergunta01,
    PERGUNTA_02: validatorConsultaSeguimentoPergunta02,
    PERGUNTA_03: validatorConsultaSeguimentoPergunta03,
    PERGUNTA_04: validatorConsultaSeguimentoPergunta04,
    PERGUNTA_05: createValidator<ConsultaSeguimentoAplicacaoItemModel>({
      resultado: required,
    }),
    PERGUNTA_06: validatorConsultaSeguimentoPergunta06,
    PERGUNTA_07: validatorConsultaSeguimentoPergunta07,
    PERGUNTA_08: validatorConsultaSeguimentoPergunta08,
    PERGUNTA_09: createValidator<ConsultaSeguimentoAplicacaoItemModel>({
      resultado: required,
    }),
    PERGUNTA_10: createValidator<ConsultaSeguimentoAplicacaoItemModel>({
      resultado: required,
    }),
    PERGUNTA_11: createValidator<ConsultaSeguimentoAplicacaoItemModel>({
      resultado: required,
    }),
    PERGUNTA_12: createValidator<ConsultaSeguimentoAplicacaoItemModel>({
      resultado: required,
    }),
    PERGUNTA_13: validatorConsultaSeguimentoPergunta13,
    PERGUNTA_14: createValidator<ConsultaSeguimentoAplicacaoItemModel>({
      resultado: required,
    }),
    PERGUNTA_15: validatorConsultaSeguimentoPergunta15,
    PERGUNTA_16: createValidator<ConsultaSeguimentoAplicacaoItemModel>({
      resultado: required,
    }),
    PERGUNTA_17: validatorConsultaSeguimentoPergunta17,
    PERGUNTA_18: createValidator<ConsultaSeguimentoAplicacaoItemModel>({
      resultado: required,
    }),
    PERGUNTA_19: validatorConsultaSeguimentoPergunta19,
    PERGUNTA_20: createValidator<ConsultaSeguimentoAplicacaoItemModel>({
      resultado: required,
    }),
  }),
})

export const isStatusValid = (value: ConsultaSeguimentoPerguntaStatusEnum) => {
  if (
    ![
      ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_FALHOU,
      ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_PASSOU,
      ConsultaSeguimentoPerguntaStatusEnum.FINALIZADO_FALHOU,
      ConsultaSeguimentoPerguntaStatusEnum.FINALIZADO_PASSOU,
    ].includes(value)
  ) {
    return 'Status inválido'
  }
}
